var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.info)?_c('div',{staticClass:"alert alert-success"},[_vm._v(" "+_vm._s(_vm.info)+" ")]):_vm._e(),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }